export const SVGRight = () => (
  <svg
    style={{
      height: "248px",
      width: "248px",
      right: "-74px",
      bottom: "-180px",
    }}
    id="deco-full-circle-rose"
    width="248"
    height="248"
    viewBox="0 0 248 248"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle r="124" transform="matrix(1 0 0 -1 124 124)" fill="#FAB8C4" />
  </svg>
);
